import React, { useEffect, useState } from 'react';

const QuadratureElement = ({quadraturaOreData, bold}) => {
    const [quadraturaOre, setQuadraturaOre] = useState([]);

    useEffect(() => {
        console.log("=== DEBUG COMPLETO ===");
        console.log("1. quadraturaOreData:", quadraturaOreData);
        console.log("2. Type:", typeof quadraturaOreData);
        console.log("3. Is Array:", Array.isArray(quadraturaOreData));
        console.log("4. Length:", quadraturaOreData?.length);
        
        // NON processare se non è un array o è vuoto
        if (!Array.isArray(quadraturaOreData) || quadraturaOreData.length === 0) {
            console.log("5. ⚠️ Array vuoto o non valido, skip processing");
            setQuadraturaOre([]);
            return;
        }

        // Debug primo elemento
        console.log("6. Primo elemento RAW:", quadraturaOreData[0]);
        console.log("7. gennaio.totale primo elemento:", quadraturaOreData[0]?.gennaio?.totale);
        console.log("8. Type gennaio.totale:", typeof quadraturaOreData[0]?.gennaio?.totale);

        // Passa DIRETTAMENTE i dati senza trasformazione
        setQuadraturaOre(quadraturaOreData);
        console.log("9. ✅ Dati settati nello state");
        
    }, [quadraturaOreData]);

    const safeGetValue = (value) => {
        console.log("safeGetValue chiamato con:", value, "Type:", typeof value);
        
        // Caso 1: già una stringa valida
        if (typeof value === 'string' && value.trim() !== '') {
            // Se contiene ":", assumiamo sia già formattata
            if (value.includes(':')) {
                return value;
            }
            // Se è una stringa numerica, parsala
            const parsed = parseFloat(value);
            if (!isNaN(parsed)) {
                return fromMinutiToOreString(parsed);
            }
        }
        
        // Caso 2: numero valido
        if (typeof value === 'number' && !isNaN(value)) {
            return fromMinutiToOreString(value);
        }
        
        // Caso 3: valore non valido
        console.log("⚠️ Valore non valido, ritorno 00:00");
        return "00:00";
    };

    const fromMinutiToOreString = (minutiTotali) => {
        console.log("fromMinutiToOreString chiamato con:", minutiTotali);
        
        // Verifica che sia un numero valido
        if (typeof minutiTotali !== 'number') {
            console.log("❌ Non è un numero, type:", typeof minutiTotali);
            return "00:00";
        }
        
        if (isNaN(minutiTotali)) {
            console.log("❌ È NaN");
            return "00:00";
        }

        let minutiTotaliAbs = Math.abs(minutiTotali);
        var minuti = Math.floor(minutiTotaliAbs % 60);
        var ore = Math.floor((minutiTotaliAbs - minuti) / 60);
        
        console.log("Conversione:", minutiTotali, "->", ore, "ore", minuti, "minuti");
        
        if (minutiTotali >= 0) {
            return formattaOre(ore) + ":" + formattaMinuti(minuti);
        } else {
            return "-" + formattaOre(ore) + ":" + formattaMinuti(minuti);
        }
    }

    const formattaOre = (ore) => {
        const num = Math.floor(Number(ore) || 0);
        return (num <= 9 ? "0" : "") + num;
    }

    const formattaMinuti = (minuti) => {
        const num = Math.floor(Number(minuti) || 0);
        return (num <= 9 ? "0" : "") + num;
    }

    const onChangeData = (i, mese, field, value) => {
        let array = [...quadraturaOre]
        array[i][mese][field] = value
        setQuadraturaOre(array)        
    }

    console.log("=== RENDERING ===");
    console.log("State quadraturaOre:", quadraturaOre);
    console.log("Length:", quadraturaOre.length);

    // NON renderizzare se non ci sono dati
    if (!quadraturaOre || quadraturaOre.length === 0) {
        console.log("⚠️ Nessun dato da renderizzare");
        return null;
    }

    return (
        <>
            {quadraturaOre.map((el, i) => {
                console.log(`Rendering riga ${i}:`, el);
                console.log(`  -> gennaio.totale:`, el.gennaio?.totale, "Type:", typeof el.gennaio?.totale);
                
                return (
                    <div key={"quadraturaOreElement" + i} className={`w-layout-grid div_column_quadrature_ore${bold ? ' testi-grassetto' : ''}`}>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <div className="item_table_quadratura">{el.descrizione || ''}</div>
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <div className="item_table_quadratura"></div>
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <div className="item_table_quadratura">
                                <input 
                                    type="text" 
                                    name="gennaio.totale" 
                                    value={safeGetValue(el.gennaio?.totale)} 
                                    onChange={(e) => {onChangeData(i, 'gennaio', 'totale', e.target.value)}} 
                                    className="input w-input edit_quadratura item_table_quadratura"
                                />
                            </div>
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="febbraio.totale" 
                                value={safeGetValue(el.febbraio?.totale)} 
                                onChange={(e) => {onChangeData(i, 'febbraio', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="marzo.totale" 
                                value={safeGetValue(el.marzo?.totale)} 
                                onChange={(e) => {onChangeData(i, 'marzo', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="aprile.totale" 
                                value={safeGetValue(el.aprile?.totale)} 
                                onChange={(e) => {onChangeData(i, 'aprile', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="maggio.totale" 
                                value={safeGetValue(el.maggio?.totale)} 
                                onChange={(e) => {onChangeData(i, 'maggio', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="giugno.totale" 
                                value={safeGetValue(el.giugno?.totale)} 
                                onChange={(e) => {onChangeData(i, 'giugno', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="luglio.totale" 
                                value={safeGetValue(el.luglio?.totale)} 
                                onChange={(e) => {onChangeData(i, 'luglio', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="agosto.totale" 
                                value={safeGetValue(el.agosto?.totale)} 
                                onChange={(e) => {onChangeData(i, 'agosto', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="settembre.totale" 
                                value={safeGetValue(el.settembre?.totale)} 
                                onChange={(e) => {onChangeData(i, 'settembre', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="ottobre.totale" 
                                value={safeGetValue(el.ottobre?.totale)} 
                                onChange={(e) => {onChangeData(i, 'ottobre', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="novembre.totale" 
                                value={safeGetValue(el.novembre?.totale)} 
                                onChange={(e) => {onChangeData(i, 'novembre', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="dicembre.totale" 
                                value={safeGetValue(el.dicembre?.totale)} 
                                onChange={(e) => {onChangeData(i, 'dicembre', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                        <div className="div_item_column div_item_column_quadratura_ore">
                            <input 
                                type="text" 
                                name="totale.totale" 
                                value={safeGetValue(el.totale?.totale)} 
                                onChange={(e) => {onChangeData(i, 'totale', 'totale', e.target.value)}} 
                                className="input w-input edit_quadratura item_table_quadratura"
                            />
                        </div>
                    </div>
                );
            })}
        </>
    )
}

export default QuadratureElement;
